
<p class="flex justify-content-center" style="white-space: nowrap"> 
  <span [style.max-width]="maxWidth" [ngClass]="{'ellipses': maxWidth != ''}" [pTooltip]=" maxWidth? list[0] : ''" tooltipPosition="top">
    {{ key ? list[0][key] : list[0] }}
  </span> 
    <span [pTooltip]="tooltipContent" tooltipPosition="bottom" class="flex align-items-center justify-content-center split-badge ml-1" *ngIf="list.length > 1"
      >+{{ list.length - 1 }}</span
    >
</p>

<ng-template #tooltipContent>
  <div class="flex flex-column justify-content-start align-items-start">
    <ng-container *ngFor="let unidade of list; let i = index">
      <span class="p-0 text-xs py-1" *ngIf="i > 0">
        {{ key ? unidade[key] : unidade }}
      </span>
    </ng-container>
  </div>
</ng-template>